import React, { Component, PropTypes } from 'react';
import { connect } from 'react-redux';
import { Checkbox } from 'sabre-spark-react';
import { merge, get, uniq, values, unset } from 'lodash';
import CTModal from '../helpers/CTModal';
import { withRouter } from 'react-router';
import { envValue } from '../../../config/envUtils';

import { checkPermissions } from '../../../lib/utils';
import { hasFailedServices, retryFailedServices } from '../../actions/retry';
import { APP_LEAVING, SAVE_STORE_SAVED_ON_SERVER, ADD_THEME_LIST, ADD_CONFIG_LIST } from '../../constants/ActionTypes';
import { SAVE_LEVEL } from '../../constants/Level';

import {
    ThemeService,
    checkIfThemeExists,
    saveThemeCodeToFrontman,
    clearSbemThemeCache
} from '../../services/ThemeService';
import {
    ConfigurationService,
    checkIfTemplateExists,
    saveTemplateToFrontman,
    clearSbemConfigCache
} from '../../services/ConfigurationService';
import { ControlledRadioButton as SparkRadioButton } from '../ui/sabre-spark-react-ex';
import { filterThemeUniqueGlobal } from '../../constants/uniqueKeyToGlobalMap';
import { ACCESS_POINTS_GROUP } from '../../constants/AccessPoints';
import RetryServiceErrorMessage from './RetryServiceErrorMessage';
import ServiceErrorMessage from './ServiceErrorMessage';
import If from '../helpers/if';

import { saveThirdpartyApps, saveLocalChanges, updateThirdpartyDomains } from '../../actions/thirdparty';
import { saveThemeFile } from '../../actions/theme';
import { saveConfigurationFile } from '../../actions/configuration';
import { sanitizeConfig } from '../../utils/configuration-utils';
import InputTextField from 'components/common/InputTextField';
import { SANITIZATION_TYPES } from '../common/sanitizationTypes';
import {
    themeOrConfigCodeSanitizeRegex,
    DISALLOWED_CONFIG_OR_THEME_CODES
} from '../../constants'

class ModalSave extends Component {
    constructor(props) {
        super(props);
        this.onClose = this.onClose.bind(this);
        this.onOpen = this.onOpen.bind(this);
        this.onSave = this.onSave.bind(this);
        this.state = {
            selectedTheme: 'oldTheme',
            themeCode: '',
            themeName: '',
            selectedConfig: 'oldConfig',
            configCode: '',
            configName: '',
            comments: '',
            saveLabels: true,
            configComments: '',
            manageAppsComments: '',
            showErrors: false,
            showThemeName: false,
            showConfigName: false,
            themeServiceFail: false,
            configServiceFail: false,
            hasDisallowedConfigCode: false,
            hasDisallowedThemeCode: false
        };
    }

    resetForm() {
        this.setState({
            comments: '',
            themeCode: '',
            themeName: '',
            configComments: '',
            configCode: '',
            configName: '',
            showErrors: false,
            showThemeName: false,
            showConfigName: false,
            manageAppsComments: '',
            hasDisallowedConfigCode: false,
            hasDisallowedThemeCode: false
        });
    }

    componentDidMount() {}

    componentWillReceiveProps(nextProps) {
        const themeCodeCheck = nextProps.themeList
            ? nextProps.themeList.find(
                  elem => elem.level === nextProps.selectedLevel && elem.ContentCode === nextProps.contentCode
              )
            : null;
        const configCodeCheck = nextProps.configList
            ? nextProps.configList.find(
                  elem => elem.level === nextProps.selectedLevel && elem.ContentCode === nextProps.configCode
              )
            : null;
        if (nextProps.configCode !== 'systemdefault' && configCodeCheck) {
            this.setState({ selectedConfig: 'oldConfig' });
        } else {
            this.setState({ selectedConfig: 'newConfig' });
        }
        if (nextProps.contentCode !== 'systemdefault' && themeCodeCheck) {
            this.setState({ selectedTheme: 'oldTheme' });
        } else {
            this.setState({ selectedTheme: 'newTheme' });
        }
    }

    onClose() {
        this.props.close();
        this.resetForm();
        this.setState({themeServiceFail: false})
        this.setState({configServiceFail: false})
    }

    getNameByCodeFromList(list, code, isHotel) {
        const configs = _.filter(list, element => element.ContentCode === code);
        if (configs.length <= 1) {
            return get(configs[0], 'MetaData.Name', '');
        }
        const hotelOrChainConfig = configs.find(element => {
            return isHotel ? element.level === 'hotel' : element.level === 'chain';
        });

        return get(hotelOrChainConfig, 'MetaData.Name', '');
    }

    isSaveDisabled() {
        const {
            themeChange,
            hasFailedThemeServices,
            thirdpartyManageAppsChanged,
            themeFileChanged,
            configFileChanged
        } = this.props;

        const {
            hasDisallowedThemeCode,
            hasDisallowedConfigCode
        } = this.state

        if (hasDisallowedThemeCode || hasDisallowedConfigCode) {
            return true;
        }

        if (themeChange) {
            return hasFailedThemeServices;
        }

        if (thirdpartyManageAppsChanged && !this.state.manageAppsComments) {
            return true;
        }

        if (themeFileChanged) {
            return hasFailedThemeServices;
        }

        if (configFileChanged) {
            return false;
        }

        return false;
    }

    saveSalesforceAllowedDomains = allowedDomains => {
        const { cspConfiguration, saveLocalChanges, thirdparty, updateThirdpartyDomains, selected } = this.props;
        const domains = get(thirdparty, `data.${cspConfiguration}.listOfDefaultDomains`, []);
        const hotel = get(selected, 'selectedHotel.id');
        const chain = get(selected, 'chain.Id');
        const selectedLevel = get(selected, 'level');
        saveLocalChanges([...domains, ...allowedDomains]);
        updateThirdpartyDomains(chain, hotel, selectedLevel);
    };

    async onSave() {
        let { selected } = this.context.store.getState().app;
        const { currentTheme, currentConfigCode, retailProductCategories } = this.props;
        const chainId = this.props.selected.chain.Id;
        const hotelId = this.props.selected.selectedHotel.id;
        const selectedLevel = this.props.selectedLevel;
        const SOURCEURL = envValue('SOURCEURL');
        const currentThemeName = this.getNameByCodeFromList(this.props.themeList, this.props.contentCode, !!hotelId);
        const currentConfigName = this.getNameByCodeFromList(this.props.configList, this.props.configCode, !!hotelId);
        const salesforceAllowedDomains = uniq(
            values(get(this.context.store.getState(), 'manage.allowedSalesforceDomains'))
        );
        // remove false If confition below once salesforce/barcelo feature is no longer blocked
        if (false) {
            this.saveSalesforceAllowedDomains(salesforceAllowedDomains);
        }
        // Build theme data based on category
        let theme;
        const isSbemCategory = this.props.themeChangeCategory === 'SBEM';
        
        if (isSbemCategory) {
            theme = this.props.inContextTheme;
        } else {
            theme = merge(
                {
                    ...this.props.currentState.app.selected.currentTheme,
                    fontsUsage: currentTheme.fontsUsage //do full override, dont merge
                },
                //modified
                {
                    input: currentTheme.form.input,
                    button: currentTheme.buttons.button,
                    message: currentTheme.colors.message,
                    palette: currentTheme.colors,
                    background: currentTheme.colors.background,
                    border: currentTheme.colors.border,
                    page: currentTheme.page,
                    h1: currentTheme.global.h1,
                    h2: currentTheme.global.h2,
                    h3: currentTheme.global.h3,
                    h4: currentTheme.global.h4,
                    h5: currentTheme.global.h5,
                    font: currentTheme.global.font,
                    link: currentTheme.links,
                    calendar: currentTheme.calendar.calendar,
                    gallery: currentTheme.carousel.gallery,
                    header: currentTheme.header,
                    heroImage: currentTheme.header.heroImage,
                    progressIndicator: currentTheme.header.progressIndicator,
                    customContent: currentTheme.customContent.customContent,
                    landingPage: currentTheme.header.landingPage
                },
                //old code mapping
                {
                    header: {
                        hamburgerMenu: {
                            ...currentTheme.header.hamburgerMenu
                        }
                    }
                }
            );
        }
        const combinedObj = {
            Data: isSbemCategory ? theme : filterThemeUniqueGlobal(theme),
            MetaData: {
                Comment: this.state.comments,
                Name: this.state.themeName || currentThemeName
            }
        };
        const config = sanitizeConfig(this.props.currentConfigCopy, retailProductCategories);
        unset(config, 'crm.enabled');
        const combinedConfigObj = {
            Data: config,
            MetaData: {
                Comment: this.state.configComments,
                Name: this.state.configName || currentConfigName
            }
        };
        const newThemeError =
            this.state.selectedTheme === 'newTheme' && (!this.state.themeCode || !this.state.themeName);
        const currentThemeNameError =
            this.state.selectedTheme !== 'newTheme' && !currentThemeName && !this.state.themeName;
        const themeValidationError = newThemeError || currentThemeNameError;
        const newConfigError =
            this.state.selectedConfig === 'newConfig' && (!this.state.configCode || !this.state.configName);
        const currentConfigNameError =
            this.state.selectedConfig !== 'newConfig' && !currentConfigName && !this.state.configName;
        const configValidationError = newConfigError || currentConfigNameError;
        const validationError =
            (this.props.themeChange && themeValidationError) ||
            (this.props.configChange && configValidationError) ||
            (this.props.themeFileChanged && (themeValidationError || !this.state.comments || !this.state.themeName)) ||
            (this.props.configFileChanged &&
                (configValidationError || !this.state.configComments || !this.state.configName));
        if (!validationError) {
            const promises = [];
            if (this.props.themeChange) {
                const newThemeCode = this.state.themeCode;
                const isThemeSaveAsNew = this.state.selectedTheme === 'newTheme';
                let themePromise;
                if (isThemeSaveAsNew) {
                    themePromise = isSbemCategory
                        ? ThemeService.newSbem(chainId, hotelId, newThemeCode, combinedObj, this.props.selected.level)
                        : ThemeService.new(chainId, hotelId, newThemeCode, combinedObj, this.props.selected.level);
                } else {
                    themePromise = isSbemCategory
                        ? ThemeService.updateSbem(chainId, hotelId, this.props.selected.code, combinedObj, this.props.selected.level)
                        : ThemeService.update(chainId, hotelId, this.props.selected.code, combinedObj, this.props.selected.level);
                }
                themePromise.then(response => {
                        if (response.data.Result.ResultCode === 'SUCCESS') {
                            if (isThemeSaveAsNew) {
                                saveThemeCodeToFrontman({
                                    code: newThemeCode,
                                    chainId,
                                    hotelId,
                                    saveLevel: this.props.selected.level,
                                    name: get(combinedObj, 'MetaData.Name')
                                });
                            } else {
                                checkIfThemeExists({ chainId, hotelId, shellCode: this.props.selected.code }).then(
                                    response => {
                                        if (!response) {
                                            saveThemeCodeToFrontman({
                                                code: this.props.selected.code,
                                                chainId,
                                                hotelId,
                                                saveLevel: this.props.selected.level,
                                                name: get(combinedObj, 'MetaData.Name')
                                            });
                                        }
                                        if (isSbemCategory) {
                                            clearSbemThemeCache(chainId, hotelId, this.props.selected.code, this.props.selected.level);
                                        }
                                    }
                                );
                            }
                            this.setState({ themeServiceFail: false });
                            return ThemeService.reload(
                                chainId,
                                hotelId,
                                this.props.selected.level,
                                this.state.selectedTheme === 'newTheme' ? newThemeCode : this.props.selected.code,
                                true,
                                isSbemCategory ? 'SBEM' : 'SBE'
                            );
                        } else {
                            return Promise.reject(response.data.Result.ResultCode);
                        }
                })
                .catch((error) => {
                        const errorResult = error.response.data.Result;
                        const errorDescription = errorResult.Description;
                        if (errorDescription === 'The key is already present in cache') {
                            this.setState({ themeServiceFail: true });
                        }
                }).finally(() => {
                        // Can do action after finishing all work.
                });
                promises.push(themePromise);
            }
            if (this.props.configChange) {
                const newConfigCode = this.state.configCode;
                const isConfigSaveAsNew = this.state.selectedConfig === 'newConfig';
                const configPromise = isConfigSaveAsNew
                    ? ConfigurationService.new(
                          chainId,
                          hotelId,
                          newConfigCode,
                          combinedConfigObj,
                          this.props.selected.level
                      )
                    : ConfigurationService.update(
                          chainId,
                          hotelId,
                          currentConfigCode,
                          combinedConfigObj,
                          this.props.selected.level
                      );
                configPromise
                    .then(response => {
                        if (response.data.Result.ResultCode === 'SUCCESS') {
                            if (isConfigSaveAsNew) {
                                saveTemplateToFrontman({
                                    code: newConfigCode,
                                    chainId,
                                    hotelId,
                                    saveLevel: this.props.selected.level,
                                    name: get(combinedConfigObj, 'MetaData.Name')
                                });
                            } else {
                                checkIfTemplateExists({ chainId, hotelId, templateCode: currentConfigCode }).then(
                                    response => {
                                        if (!response) {
                                            saveTemplateToFrontman({
                                                code: currentConfigCode,
                                                chainId,
                                                hotelId,
                                                saveLevel: this.props.selected.level,
                                                name: get(combinedConfigObj, 'MetaData.Name')
                                            });
                                        }
                                        if (this.props.inContextBeta) {
                                            clearSbemConfigCache(chainId, hotelId, currentConfigCode, this.props.selected.level);
                                        }
                                    }
                                );
                            }
                            this.setState({ configServiceFail: false });
                            return ConfigurationService.reload(
                                chainId,
                                hotelId,
                                this.props.selected.level,
                                this.state.selectedConfig === 'newConfig' ? newConfigCode : currentConfigCode,
                                true
                            );
                        } else {
                            return Promise.reject(response.data.Result.ResultCode);
                        }
                    })
                    .catch((error) => {
                        const errorResult = error.response.data.Result;
                        const errorDescription = errorResult.Description;
                        if (errorDescription === 'The key is already present in cache') {
                            this.setState({ configServiceFail: true });
                        }
                    })
                    .finally(() => {
                        // Can do action after finishing all work.
                    });
                promises.push(configPromise);
            }

            if (this.props.labelsChanged && this.state.saveLabels) {
                this.props.labelsSaveHandler();
            }

            if (this.props.thirdpartyManageAppsChanged) {
                const { thirdpartyManageApps } = this.props;
                if (_.get(thirdpartyManageApps, 'trivago.advertiserIdIsInvalid', '')) {
                    this.props.close();
                    return;
                }

                this.props.setThirdpartyManageApps(
                    chainId,
                    hotelId,
                    selectedLevel,
                    thirdpartyManageApps,
                    this.state.manageAppsComments
                );
            }

            if (this.props.themeFileChanged) {
                this.props
                    .setThemeFileData(this.props.selected, {
                        name: this.state.themeName,
                        comments: this.state.comments,
                        code: this.state.themeCode
                    })
                    .then(() => {
                        this.props.router.push('/manage/manage-theme');
                    })
                    .finally(() => {
                        this.setState({
                            themeCode: '',
                            themeName: '',
                            comment: ''
                        });
                    });
            }

            if (this.props.configFileChanged) {
                const configFileData = sanitizeConfig(this.props.configFileToSave, retailProductCategories)
                this.props
                    .setConfigFileData(this.props.selected, this.props.configCode, configFileData, {
                        name: this.state.configName,
                        comments: this.state.configComments,
                        code: this.state.configCode
                    })
                    .then(() => {
                        this.props.router.push('/manage/manage-configuration');
                    })
                    .finally(() => {
                        this.setState({
                            configName: '',
                            configComments: '',
                            configCode: ''
                        });
                    });
            }

            if (promises.length === 0) {
                this.props.edit(true, true);
                this.onClose();
                return;
            }
            const results = await Promise.allSettled(promises);
            const hasPending = results.some(result => result.status === "pending");

            if (!hasPending && !(this.state.themeServiceFail || this.state.configServiceFail)) {
                this.props.edit(true, true);
                this.onClose();
            }

        } else {
            this.setState({
                showErrors: true,
                showThemeName: currentThemeNameError,
                showConfigName: currentConfigNameError
            });
        }
    }

    onOpen() {
        const hotelId = this.props.selected.selectedHotel.id;
        if (this.props.themeFileChanged) {
            const currentThemeName = this.getNameByCodeFromList(
                this.props.themeList,
                this.props.contentCode,
                !!hotelId
            );
            this.setState({
                themeCode: this.props.contentCode,
                themeName: this.props.contentCode ? currentThemeName : '',
                comment: ''
            });
        }

        if (this.props.configFileChanged) {
            const currentConfigName = this.getNameByCodeFromList(
                this.props.configList,
                this.props.configCode,
                !!hotelId
            );
            this.setState({
                configComments: '',
                configCode: this.props.currentConfigCode,
                configName: this.props.currentConfigCode ? currentConfigName : ''
            });
        }
    }

    getThemeOrConfigCodeErrorMessage(hasDisallowedThemeOrConfigCode) {
        if (!this.state.themeCode && this.state.showErrors) {
            return 'Field is required';
        } else if (hasDisallowedThemeOrConfigCode) {
            return 'This code cannot be used'
        } else {
            return '';
        }
    }

    render() {
        const themeCodeCheck = this.props.themeList
            ? this.props.themeList
                  .filter(elem => {
                      return elem.level === this.props.selectedLevel;
                  })
                  .find(element => {
                      return element.ContentCode === this.props.contentCode;
                  })
            : null;
        const configCodeCheck = this.props.configList
            ? this.props.configList
                  .filter(elem => {
                      return elem.level === this.props.selectedLevel;
                  })
                  .find(element => {
                      return element.ContentCode === this.props.currentConfigCode;
                  })
            : null;

        return (
            <CTModal
                open={this.props.open}
                primaryButtonTitle="Save"
                primaryButton={true}
                primaryButtonClick={this.onSave}
                primaryButtonDisabled={this.isSaveDisabled()}
                onClose={this.onClose}
                onOpen={this.onOpen}
                secondaryButton={true}
                secondaryButtonClick={this.onClose}
                secondaryButtonTitle="Cancel"
            >
                <div className="modal-save-mb-50">
                    {this.props.themeChange ? (
                        <div>
                            <If condition={this.props.hasFailedThemeServices}>
                                <RetryServiceErrorMessage
                                    heading="Some Theme Services have Failed"
                                    message="Saving has been disabled. Please click icon to retry or restart the application."
                                    onClick={() => this.props.retryFailedServices('theme')}
                                />
                            </If>
                            <If condition={this.state.themeServiceFail}>
                                <ServiceErrorMessage
                                    heading="New theme not saved"
                                    message="The theme code provided already exists.  Please use a different code and try again."
                                />
                            </If>
                            <h4 className="modal-save-mb-12">Save Theme Changes</h4>
                            <div className="modal-save-mb-13">APPLY CHANGES TO</div>
                            {this.props.contentCode !== 'systemdefault' && themeCodeCheck ? (
                                <SparkRadioButton
                                    name="add-theme-toggle"
                                    onClick={event => {
                                        const value = event.target.value;
                                        setTimeout(() => this.setState({ selectedTheme: value }), 0);
                                    }}
                                    checked={this.state.selectedTheme === 'oldTheme'}
                                    value={'oldTheme'}
                                >
                                    This theme only
                                </SparkRadioButton>
                            ) : null}
                            {this.state.selectedTheme === 'oldTheme' && (
                                <div>
                                    <div className="modal-save-mb-10" />
                                    {this.state.showThemeName && (
                                        <div className="col-xs">
                                            <InputTextField
                                                sparkInputProps={{
                                                    label: 'Theme Name',
                                                    errorMessage:
                                                        !this.state.themeName && this.state.showErrors
                                                            ? 'Field is required'
                                                            : ''
                                                }}
                                                name="theme-name"
                                                value={this.state.themeName}
                                                onChange={value => {
                                                    this.setState({ themeName: value });
                                                }}
                                            />
                                        </div>
                                    )}
                                    <div className="modal-save-mb-10" />
                                    {this.state.showThemeName && (
                                        <div className="col-xs">
                                            <InputTextField
                                                disabled
                                                sparkInputProps={{ label: 'Theme Code' }}
                                                name="theme-code"
                                                value={this.props.contentCode}
                                            />
                                        </div>
                                    )}
                                    <div className="modal-save-mb-10" />
                                    <div className="col-xs">
                                        <InputTextField
                                            sparkInputProps={{ label: 'Change Comments' }}
                                            name="theme-comments"
                                            value={this.state.comments}
                                            sanitizationType={SANITIZATION_TYPES.BLACK_LIST}
                                            replaceWith={{ '&lt;': '<', '&gt;': '>' }}
                                            onChange={value => {
                                                this.setState({ comments: value });
                                            }}
                                        />
                                    </div>
                                    <div className="modal-save-mb-10" />
                                </div>
                            )}
                            {this.props.hasAccessToTheme.add && (
                                <SparkRadioButton
                                    name="add-theme-toggle"
                                    onClick={event => {
                                        const value = event.target.value;
                                        setTimeout(() => this.setState({ selectedTheme: value }), 0);
                                    }}
                                    checked={this.state.selectedTheme === 'newTheme'}
                                    value={'newTheme'}
                                >
                                    A new theme
                                </SparkRadioButton>
                            )}
                            {this.props.hasAccessToTheme.add && this.state.selectedTheme === 'newTheme' && (
                                <div>
                                    <div className="modal-save-mb-10" />
                                    <div className="col-xs">
                                        <InputTextField
                                            sparkInputProps={{
                                                label: 'Theme Name',
                                                errorMessage:
                                                    !this.state.themeName && this.state.showErrors
                                                        ? 'Field is required'
                                                        : ''
                                            }}
                                            name="theme-name"
                                            value={this.state.themeName}
                                            onChange={value => {
                                                this.setState({ themeName: value });
                                            }}
                                        />
                                    </div>
                                    <div className="modal-save-mb-10" />
                                    <div className="col-xs">
                                        <InputTextField
                                            sparkInputProps={{
                                                label: 'Theme Code',
                                                errorMessage: this.getThemeOrConfigCodeErrorMessage(this.state.hasDisallowedThemeCode)
                                            }}
                                            name="theme-code"
                                            value={this.state.themeCode}
                                            onChange={value => {
                                                this.setState({
                                                    themeCode: value,
                                                    hasDisallowedThemeCode: DISALLOWED_CONFIG_OR_THEME_CODES.includes(value)
                                                });
                                            }}
                                            sanitizationType={SANITIZATION_TYPES.REGEXP}
                                            sanitizeRegExp={themeOrConfigCodeSanitizeRegex}
                                        />
                                    </div>
                                    <div className="modal-save-mb-10" />
                                    <div className="col-xs">
                                        <InputTextField
                                            sparkInputProps={{
                                                label: 'Change Comments'
                                            }}
                                            name="theme-comments"
                                            value={this.state.comments}
                                            sanitizationType={SANITIZATION_TYPES.BLACK_LIST}
                                            replaceWith={{ '&lt;': '<', '&gt;': '>' }}
                                            onChange={value => {
                                                this.setState({ comments: value });
                                            }}
                                        />
                                    </div>
                                </div>
                            )}
                        </div>
                    ) : null}
                    {this.props.configChange ? (
                        <div>
                            <If condition={this.state.configServiceFail}>
                                <ServiceErrorMessage
                                    heading="New configuration not saved"
                                    message="The configuration code provided already exists.  Please use a different code and try again."
                                />
                            </If>
                            <h4 className="modal-save-mb-12">Save Configuration Changes</h4>
                            <div className="modal-save-mb-13">APPLY CHANGES TO</div>
                            {this.props.configCode !== 'systemdefault' && configCodeCheck ? (
                                <SparkRadioButton
                                    name="add-config-toggle"
                                    onClick={event => {
                                        const value = event.target.value;
                                        setTimeout(() => this.setState({ selectedConfig: value }), 0);
                                    }}
                                    value={'oldConfig'}
                                    checked={this.state.selectedConfig === 'oldConfig'}
                                >
                                    This configuration only
                                </SparkRadioButton>
                            ) : null}
                            {this.state.selectedConfig === 'oldConfig' && (
                                <div>
                                    <div className="modal-save-mb-10" />
                                    {this.state.showConfigName && (
                                        <div className="col-xs">
                                            <InputTextField
                                                sparkInputProps={{
                                                    errorMessage:
                                                        !this.state.configName && this.state.showErrors
                                                            ? 'Field is required'
                                                            : '',
                                                    label: 'Configuration Name'
                                                }}
                                                name="config-name"
                                                value={this.state.configName}
                                                onChange={value => {
                                                    this.setState({ configName: value });
                                                }}
                                            />
                                        </div>
                                    )}
                                    <div className="modal-save-mb-10" />
                                    {this.state.showConfigName && (
                                        <div className="col-xs">
                                            <InputTextField
                                                disabled
                                                sparkInputProps={{ label: 'Config Code' }}
                                                name="config-code"
                                                value={this.props.configCode}
                                            />
                                        </div>
                                    )}
                                    <div className="modal-save-mb-10" />
                                    <div className="col-xs">
                                        <InputTextField
                                            sparkInputProps={{ label: 'Change Comments' }}
                                            name="config-coments"
                                            value={this.state.configComments}
                                            sanitizationType={SANITIZATION_TYPES.BLACK_LIST}
                                            replaceWith={{ '&lt;': '<', '&gt;': '>' }}
                                            onChange={value => {
                                                this.setState({ configComments: value });
                                            }}
                                        />
                                    </div>
                                    <div className="modal-save-mb-10" />
                                </div>
                            )}

                            {this.props.hasAccessToConfiguration.add && (
                                <SparkRadioButton
                                    name="add-config-toggle"
                                    onClick={event => {
                                        const value = event.target.value;
                                        setTimeout(() => this.setState({ selectedConfig: value }), 0);
                                    }}
                                    value={'newConfig'}
                                    checked={this.state.selectedConfig === 'newConfig'}
                                >
                                    A new configuration
                                </SparkRadioButton>
                            )}
                            {this.props.hasAccessToConfiguration.add && this.state.selectedConfig === 'newConfig' && (
                                <div>
                                    <div className="modal-save-mb-10" />
                                    <div className="col-xs">
                                        <InputTextField
                                            sparkInputProps={{
                                                errorMessage:
                                                    !this.state.configName && this.state.showErrors
                                                        ? 'Field is required'
                                                        : '',
                                                label: 'Configuration Name'
                                            }}
                                            name="config-name"
                                            value={this.state.configName}
                                            onChange={value => {
                                                this.setState({ configName: value });
                                            }}
                                        />
                                    </div>
                                    <div className="modal-save-mb-10" />
                                    <div className="col-xs">
                                        <InputTextField
                                            sparkInputProps={{
                                                label: 'Config Code',
                                                errorMessage: this.getThemeOrConfigCodeErrorMessage(this.state.hasDisallowedConfigCode)
                                            }}
                                            name="config-code"
                                            value={this.state.configCode}
                                            onChange={value => {
                                                this.setState({
                                                    configCode: value,
                                                    hasDisallowedConfigCode: DISALLOWED_CONFIG_OR_THEME_CODES.includes(value)
                                                });
                                            }}
                                            sanitizationType={SANITIZATION_TYPES.REGEXP}
                                            sanitizeRegExp={themeOrConfigCodeSanitizeRegex}
                                        />
                                    </div>
                                    <div className="modal-save-mb-10" />
                                    <div className="col-xs">
                                        <InputTextField
                                            sparkInputProps={{ label: 'Change Comments' }}
                                            name="config-comments"
                                            value={this.state.configComments}
                                            sanitizationType={SANITIZATION_TYPES.BLACK_LIST}
                                            replaceWith={{ '&lt;': '<', '&gt;': '>' }}
                                            onChange={value => {
                                                this.setState({ configComments: value });
                                            }}
                                        />
                                    </div>
                                </div>
                            )}
                        </div>
                    ) : null}

                    {this.props.labelsChanged ? (
                        <div>
                            <h4 className="modal-save-mb-12">Save Label Changes</h4>
                            <Checkbox
                                label={'Save labels'}
                                value={true}
                                checked={this.state.saveLabels}
                                onChange={value => {
                                    this.setState({ saveLabels: value });
                                }}
                            />
                        </div>
                    ) : null}
                    {this.props.thirdpartyManageAppsChanged ? (
                        <div>
                            <h4 className="modal-save-mb-12">Save 3rd Party Apps Changes</h4>
                            <div className="col-xs">
                                <InputTextField
                                    sparkInputProps={{ label: 'Change Comments*' }}
                                    name="manage-apps-name"
                                    value={this.state.manageAppsComments}
                                    sanitizationType={SANITIZATION_TYPES.BLACK_LIST}
                                    replaceWith={{ '&lt;': '<', '&gt;': '>' }}
                                    onChange={value => {
                                        this.setState({ manageAppsComments: value });
                                    }}
                                />
                            </div>
                        </div>
                    ) : null}

                    {this.props.themeFileChanged ? (
                        <div>
                            <If condition={this.props.hasFailedThemeServices}>
                                <RetryServiceErrorMessage
                                    heading="Some Theme Services have Failed"
                                    message="Saving has been disabled. Please click icon to retry or restart the application."
                                    onClick={() => this.props.retryFailedServices('theme')}
                                />
                            </If>
                            <h4 className="modal-save-mb-12">Save Theme Changes</h4>
                            <div>
                                <div className="modal-save-mb-10" />
                                <div className="col-xs">
                                    <InputTextField
                                        sparkInputProps={{
                                            label: 'Theme Name*',
                                            errorMessage:
                                                !this.state.themeName && this.state.showErrors
                                                    ? 'Field is required'
                                                    : ''
                                        }}
                                        name="theme-name"
                                        value={this.state.themeName}
                                        onChange={value => {
                                            this.setState({ themeName: value });
                                        }}
                                    />
                                </div>
                                <div className="modal-save-mb-10" />
                                <div className="col-xs">
                                    <InputTextField
                                        disabled={!!this.props.contentCode}
                                        sparkInputProps={{
                                            label: 'Theme Code*',
                                            errorMessage:
                                                !this.state.themeCode && this.state.showErrors
                                                    ? 'Field is required'
                                                    : ''
                                        }}
                                        name="theme-code"
                                        value={this.state.themeCode}
                                        onChange={value => {
                                            this.setState({ themeCode: value });
                                        }}
                                    />
                                </div>
                                <div className="modal-save-mb-10" />
                                <div className="col-xs">
                                    <InputTextField
                                        sparkInputProps={{
                                            label: 'Change Comments*',
                                            errorMessage:
                                                !this.state.comments && this.state.showErrors ? 'Field is required' : ''
                                        }}
                                        name="theme-comments"
                                        value={this.state.comments}
                                        sanitizationType={SANITIZATION_TYPES.BLACK_LIST}
                                        replaceWith={{ '&lt;': '<', '&gt;': '>' }}
                                        onChange={value => {
                                            this.setState({ comments: value });
                                        }}
                                    />
                                </div>
                            </div>
                        </div>
                    ) : null}

                    {this.props.configFileChanged ? (
                        <div>
                            <h4 className="modal-save-mb-12">Save Configuration Changes</h4>
                            <div>
                                <div className="modal-save-mb-10" />
                                <div className="col-xs">
                                    <InputTextField
                                        sparkInputProps={{
                                            label: 'Configuration Name*',
                                            errorMessage:
                                                !this.state.configName && this.state.showErrors
                                                    ? 'Field is required'
                                                    : ''
                                        }}
                                        name="config-name"
                                        value={this.state.configName}
                                        onChange={value => {
                                            this.setState({ configName: value });
                                        }}
                                    />
                                </div>
                                <div className="modal-save-mb-10" />
                                <div className="col-xs">
                                    <InputTextField
                                        disabled={!!this.props.configCode}
                                        sparkInputProps={{
                                            label: 'Configuration Code*',
                                            errorMessage:
                                                !this.state.configCode && this.state.showErrors
                                                    ? 'Field is required'
                                                    : ''
                                        }}
                                        name="config-code"
                                        value={this.state.configCode}
                                        onChange={value => {
                                            this.setState({ configCode: value });
                                        }}
                                    />
                                </div>
                                <div className="modal-save-mb-10" />
                                <div className="col-xs">
                                    <InputTextField
                                        sparkInputProps={{
                                            label: 'Configuration Comments*',
                                            errorMessage:
                                                !this.state.configComments && this.state.showErrors
                                                    ? 'Field is required'
                                                    : ''
                                        }}
                                        name="config-comments"
                                        value={this.state.configComments}
                                        sanitizationType={SANITIZATION_TYPES.BLACK_LIST}
                                        replaceWith={{ '&lt;': '<', '&gt;': '>' }}
                                        onChange={value => {
                                            this.setState({ configComments: value });
                                        }}
                                    />
                                </div>
                            </div>
                        </div>
                    ) : null}
                </div>
            </CTModal>
        );
    }
}

ModalSave.defaultProps = {
    open: false
};

ModalSave.propTypes = {
    open: PropTypes.bool.isRequired,
    close: PropTypes.func.isRequired,
    retailProductCategories: PropTypes.array
};

ModalSave.contextTypes = {
    store: PropTypes.object
};

/**
 STORE stuff. See store/AppStore.js
*/

export const SHOW_MODAL_SAVE = 'SHOW_MODAL_SAVE';
export const HIDE_MODAL_SAVE = 'HIDE_MODAL_SAVE';

const initialState = {
    isOpened: false
};

export const modalSaveReducer = (state = initialState, action) => {
    switch (action.type) {
        case SHOW_MODAL_SAVE:
            return {
                isOpened: true
            };
        case HIDE_MODAL_SAVE:
        case APP_LEAVING:
            return {
                isOpened: false
            };
        default:
            return state;
    }
};

export const modalSaveActions = {
    show() {
        return dispatch => {
            dispatch({ type: SHOW_MODAL_SAVE });
        };
    },
    hide() {
        return dispatch => {
            dispatch({ type: HIDE_MODAL_SAVE });
        };
    },
    removeEdit(configSaved, themeSaved) {
        return dispatch => {
            dispatch({ type: SAVE_STORE_SAVED_ON_SERVER, configSaved, themeSaved });
        };
    }
};

/**
 /STORE stuff. See store/AppStore.js
*/

const mapStateToProps = state => {
    return {
        open: state.app.modal.save.isOpened,
        selected: state.app.selected,
        contentCode: state.app.selected.code,
        configCode: state.app.data.configuration.configuration.configCode,
        configFileToSave: state.app.data.configuration.configuration.configFileToSave,
        cspConfiguration:
            state.app.selected.level === SAVE_LEVEL.CHAIN ? 'chainCspConfiguration' : 'hotelCspConfiguration',
        theme: state.app.theme,
        currentState: state,
        currentTheme: state.app.data.theme,
        inContextTheme: state.app.data.inContextTheme,
        currentConfigCopy: state.app.data.configuration.configuration.currentConfigCopy,
        currentConfigCode: state.app.data.configuration.configuration.configCode,
        configChange: state.save.configChange,
        themeChange: state.save.themeChange,
        themeChangeCategory: state.save.themeChangeCategory,
        themeFileChanged: state.app.selected.themeFileChanged,
        configFileChanged: state.app.data.configuration.configuration.configFileChanged,
        labelsChanged: state.app.data.labels.labels.changed,
        thirdparty: get(state, 'app.data.thirdparty', {}),
        thirdpartyManageAppsChanged: get(state, 'app.data.thirdparty.changedManageApps'),
        thirdpartyManageApps: {
            sojernTracking: get(state, 'app.data.thirdparty.data.sojernTracking'),
            trivago: get(state, 'app.data.thirdparty.data.trivago'),
            tripadvisor: get(state, 'app.data.thirdparty.data.tripadvisor'),
            thehotelnetwork: get(state, 'app.data.thirdparty.data.thehotelnetwork'),
            uplift: get(state, 'app.data.thirdparty.data.uplift')
        },
        selectedLevel: state.app.selected.level,
        configList: state.app.selected.configList,
        themeList: state.app.selected.themeList,
        labelsSaveHandler: state.app.data.labels.labels.saveHandler,
        hasAccessToTheme: checkPermissions(state, ACCESS_POINTS_GROUP.THEMES),
        hasAccessToConfiguration: checkPermissions(state, ACCESS_POINTS_GROUP.CONFIGURATION),
        hasFailedThemeServices: hasFailedServices('theme', state),
        retailProductCategories: get(state, 'app.selected.retailProductCategories'),
        inContextBeta: get(state, 'app.selected.inContextBeta', false)
    };
};

const mapDispatchToProps = dispatch => ({
    close: () => dispatch(modalSaveActions.hide()),
    edit: (configSaved, themeSaved) => dispatch(modalSaveActions.removeEdit(configSaved, themeSaved)),
    saveLocalChanges: (chainId, hotelId, savedData) => {
        dispatch(saveLocalChanges(chainId, hotelId, savedData));
    },
    setThemeList: (themeList, defaultContentCode) => {
        dispatch({ type: ADD_THEME_LIST, themeList, defaultContentCode });
    },
    setConfigList: (configList, defaultContentCode) => {
        dispatch({ type: ADD_CONFIG_LIST, configList, defaultContentCode });
    },
    setThirdpartyManageApps: (chainId, hotelId, selectedLevel, savedData, comment) => {
        return dispatch(saveThirdpartyApps(chainId, hotelId, selectedLevel, savedData, comment));
    },
    retryFailedServices: type => dispatch(retryFailedServices(type)),
    setThemeFileData: (selected, params) => {
        return dispatch(saveThemeFile(selected, params));
    },
    setConfigFileData: (selected, configCode, configToSave, newParams) => {
        return dispatch(saveConfigurationFile(selected, configCode, configToSave, newParams));
    },
    updateThirdpartyDomains: (chainId, hotelId, selectedLevel) => {
        return dispatch(updateThirdpartyDomains(chainId, hotelId, selectedLevel));
    }
});

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(ModalSave));


// WEBPACK FOOTER //
// ./src/components/modals/ModalSave.js